import { Grid, Typography } from "@mui/material"
import { Pointers } from "../../../types/GiftSubscriptionLandingPage"
import styles from './GiftPointers.module.css'
import Spacer from "../../atoms/Spacer/Spacer"

interface GiftPointersProps {
    pointers: Pointers[]
}

const GiftPointers = (props: GiftPointersProps) => {
    return <>
        {props.pointers.map((entry, index) =>
            <>
                <Grid container direction={`row`} key={entry.title} wrap="nowrap">
                    <Grid item className={styles.repeatableIndexBox}>
                        <Typography className={styles.repeatableIndex}>{index + 1}</Typography>
                    </Grid>
                    <Grid item direction={`column`} key={entry.title} alignSelf={`center`}>
                        <Typography className={styles.repeatableContentTitle}>{entry.title}</Typography>
                        <Typography className={styles.repeatableContentText}>{entry.description}</Typography>
                    </Grid>
                    <Spacer height={20}/>
                </Grid>
                <Spacer height={20}/>
            </>,
        )}
    </>

}

export default GiftPointers